<template>
  <div class="toRecharge">
      <div class="rechargeContainer">
        <div class="topContainer">
          <div class="startConvert">
            <h3 style="font-size:0.28rem;font-weight:bold;text-align:left;color:rgba(51,51,51,1);padding-top:0.29rem;padding-left:0.21rem;">自定义金额:</h3>
            <div class="importCustom">
              <input id='inputVul' type="text" v-model="importCustom"  @input='changeValu()'  onpaste="return false" οncοntextmenu="return false"  οncοpy="return false" oncut="return false" placeholder="请输入充值金额">
            </div>
            <div class="no"  v-if="isNo">
             {{tipsFonts}}
            </div>

          </div>
        
        </div>
    
        <div class="tips">
          <p>充值说明:</p>
          <p>1、您所充值的余额仅可用于购买播豆、发送福袋金。</p>
          <p>2、个人充值产生的余额，目前平台无法提供提现、退款功能。</p>
          <p>3、单笔充值金额最少1元，最多2000元。</p>
          <p>4、如有充值失败等问题，可拨打客服电话（010）64716868。</p>
        </div>
        <div class="buyBean">
             <div>
              <img src="../../assets/img/isSure1.png" alt=""  v-if="isSure=='1'">
              <img src="../../assets/img/isSure2.png" alt=""  @click="wechatBuy()" v-if="isSure=='2'">
             </div>
            <p class="topAgreement">点击确认充值,即代表您已同意<a href="http://h5.cbct.cn/html/paymentA.html" style="color:#5AC8FA">《听见广播用户账户服务协议》</a></p>
        </div>
       
      </div>
    
  </div>

  
</template>

<script>
import { Toast } from 'mint-ui';
export default {
  name: 'toRecharge',
  data:function(){
    return{
    
      isNo:false,
      importCustom:'',
      isSure:'1',
      tipsFonts:'',
      isMyaccount:'',
      live_Type:'',
      number:'',
      channel_name:'',

    }
  },

  methods:{
    changeValu:function(){
    
      if(this.importCustom.toString().charAt(0)=='.'){
        this.importCustom='0.'
        return;
      }
      if(this.importCustom.toString().charAt(0)=='-'){
        this.importCustom=''
        return;
      }
      if (this.importCustom.toString().indexOf('-') !='-1') {
          this.importCustom=''
          return;
      }
      if (isNaN(this.importCustom)) {
          this.importCustom=''
          return;
      }
      if (this.importCustom.toString().indexOf('=') !='-1') {
          this.importCustom=''
          return;
      }
      if(this.importCustom.toString().charAt(0)=='='){
        this.importCustom=''
        return;
      }
      if (!this.numberCheck(this.importCustom)) {
        var realIndex = 0;
        var regs=/[a-z,A-Z]/g;
        var reg =/[\u4e00-\u9fa5]/g;
        // 去除input框输入的字母特殊符号
        for(var i = 0; i<this.importCustom.length; i++){
          var strn = this.importCustom[i];
          var regEn = /[`~!@#$%^&*()_+<>?:"{},\\/;'[\]]/im,
              regCn = /[.！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
          if (/[\u4e00-\u9fa5_a-zA-Z]/g.test(this.importCustom[i]) ||  regEn.test(this.importCustom[i]) || regCn.test(this.importCustom[i]) ){
            realIndex = i;
            this.importCustom=this.importCustom.replace(this.importCustom[realIndex],"");
           }else{
             if (this.importCustom.indexOf('.')=='-1') {
                this.importCustom = this.importCustom.substr(0, 6);        
            } 
                if (Number(this.importCustom)>2000) {
                  this.tipsFonts="单笔充值金额不能超过2000元";
                  this.isNo=true;
                   this.isSure='1';
                   $("#inputVul").css("color","#f33")
                 }else if (Number(this.importCustom)<1) {
                  this.tipsFonts="最小单笔充值金额1元";
                   $("#inputVul").css("color","#f33")
                  this.isNo=true;
                   this.isSure='1';
                }
                else{
                    let a=this.importCustom.substring(0,this.importCustom.indexOf('.')+3,1);
                    this.importCustom=parseFloat(a);
                    $("#inputVul").css("color","#000")
                    this.isNo=false;
                    this.tipsFonts='';
                    this.isSure='2';
                }
           }
         }
        let a=String(this.importCustom);
        this.importCustom = a.replace(reg,'');
        return;
      }else{ 
         if (this.importCustom.indexOf('.')=='-1') {
                this.importCustom = this.importCustom.substr(0, 6);        
            } 
          if(Number(this.importCustom)>2000) {
             
            this.tipsFonts="单笔充值金额不能超过2000元";
            $("#inputVul").css("color","#f33")
            this.isNo=true;
             this.isSure='1';
          }else if (Number(this.importCustom)<1) {
            this.tipsFonts="最小单笔充值金额1元";
            $("#inputVul").css("color","#f33")
            this.isNo=true;
             this.isSure='1';
          }else{
              this.importCustom=this.importCustom;
              $("#inputVul").css("color","#000")
              this.isNo=false;
              this.tipsFonts='';
              this.isSure='2';
          }
      }
    },
   
    numberCheck:function(num){
      var re=/^\d*\.{0,1}\d{0,1}$/;
      return re.exec(num) != null;
    },
    // 余额充值
    wechatBuy:function(){
      var chuanId = this.cbct.getCookie('user_id') == ''? this.cbct.getCookie('rc_token'):this.cbct.getCookie('user_id');

      this.getClick.getClicktime('3',this.cbct.getCookie('channel_id'),chuanId);
      var self = this;
      if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
              document.addEventListener('WeixinJSBridgeReady', this.realPay(), false);
          }else if (document.attachEvent) {
              document.attachEvent('WeixinJSBridgeReady', this.realPay());
              document.attachEvent('onWeixinJSBridgeReady', this.realPay());
          }
      }else {
        this.realPay();
      }
      
    },
    realPay:function(){
        let self = this;
        self.http.post(this.cbct.https()+'/h5/pay/wechat-pay', this.qs.stringify({
          page:'pub',
          id:'0',
          money:Number(this.importCustom*100),
          attach:'lucky_charge',
         })).then((response)=>{
            if(response.c == this.cbct.code.successRes){
                  var wxinfo =  JSON.parse(response.d.pay);
                  WeixinJSBridge.invoke(
                        'getBrandWCPayRequest', {
                            "appId":wxinfo.appId,
                            "nonceStr":wxinfo.nonceStr,
                            "package":wxinfo.package,
                            "signType":wxinfo.signType,
                            "timeStamp":wxinfo.timeStamp,
                            "paySign":wxinfo.paySign,
                        },
                        function (res) {
                            WeixinJSBridge.log(res.err_msg + 'err');
                           
                             if (res.err_msg=='get_brand_wcpay_request:ok') {
                                Toast({
                                  message: '支付成功',
                                  position: 'center',
                                  duration: 1000
                                });
                                if (self.isMyaccount=='1') {
                                  self.$router.push({
                                      path:'myAccountPage',
                                      query:{'Truechnnel_id':self.$route.query.Truechnnel_id}
                                   })
                                }else{
                                  self.$router.push({
                                    path:'cinemaList',
                                    name:'cinemaList',
                                    query:{'chnnelId':self.number,'Truechnnel_id':this.$route.query.Truechnnel_id}
                                  })
                                }
                            }else if(res.err_msg=='get_brand_wcpay_request:cancel'){
                               Toast({
                                  message: '取消支付',
                                  position: 'center',
                                  duration: 1000
                                });
                            }else{
                                Toast({
                                  message: '支付失败',
                                  position: 'center',
                                  duration: 1000
                                });
                            }
                        }

                  );
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: '服务器开小差,请稍后重试',
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                  self.$router.push({path:'./register?returnUrl=goldLucky?live_type=1&number='+this.number+'&Truechnnel_id='+this.$route.query.Truechnnel_id });
            }else{
               Toast({
                    message: '服务器开小差,请稍后重试',
                    position: 'center',
                    duration: 5000
                });
            }
            
        }
        ).catch((error)=>{console.log(error);})
    },


  
  },
  created(){
    //判断是否授权
    if(this.cbct.getCookie('openId') == undefined ||this.cbct.getCookie('openId') == ''){
        this.$router.push({path:'./change?channel_id='+this.$route.query.Truechnnel_id});
    }
    this.timing.time();
    $('title').html(decodeURIComponent(this.cbct.getCookie('channel_name')));
    let self=this;
    self.channel_name = decodeURIComponent(this.cbct.getCookie('channel_name'));
    if (self.$route.query.isMyaccount !='' || self.$route.query.isMyaccount!=undefined) {
     self.isMyaccount=self.$route.query.isMyaccount;
     self.live_Type=self.$route.query.live_Type;
     self.number=self.$route.query.number;
    }
  },
  watch:{
    // 监听输入的值
    importCustom(n,o){
      if (n=='' || n== undefined || n==null) {
         this.isNo=false;
         this.tipsFonts='';
         this.isSure='1';
      }

    }


  },
  mounted(){
   
  },
  components:{

  }
  
}


</script>
<style scoped lang="scss">
   .toRecharge{
      width: 100%;
      height: auto;
      overflow: hidden;
      box-sizing: border-box;
      -webkit-touch-callout:none;
      -webkit-user-select:none;
      -moz-user-select:none;
       -ms-user-select:none; 
       user-select:none;
       background: #F8F8F8;
       input{
         -webkit-user-select:auto;
       }
      .rechargeContainer{
        width: 100%;
        box-sizing: border-box;
        .topContainer{

          .startConvert{
            // padding: 0 0.4rem;
           .importCustom{
              padding: 0.2rem;
              input{
                width: 100%;
                box-sizing: border-box;
                font-size: 0.28rem;
                font-weight:400;
                color:rgba(51,51,51,1);
                border-radius: 0.1rem;
                padding: 0.24rem 0;
                padding-left: 0.2rem;
                border: none;
                outline: none;
                background: white;
              }
            }
            .no{
              font-weight:400;
              color:rgba(204,50,50,1);
              font-size:0.24rem;
              text-align: left;
              margin: 0.1rem 0.2rem 0.07rem;

            }

          }

        }
        .balance{
          padding: 0.42rem 0 0 0.32rem;
          font-weight:500;
          color:rgba(51,51,51,1);
          font-size: 0.3rem;
          text-align: left;
        }
      
        .tips{
          font-weight:500;
          color:rgba(153,153,153,1);
          font-size: 0.24rem;
          padding: 0.5rem 0.32rem 1.2rem 0.32rem;
          text-align: left;
          line-height: 0.4rem;
          

        }
        .buyBean{
          width: 100%;
          box-sizing: border-box;
          padding: 0 0.3rem;
          margin: auto;
          text-align: center;
        
         div{
            border-top:solid 1px rgba(221,221,221,1);
           img{
            width: 5.86rem;
            display: inline-block;
            margin: 0.27rem auto 0.11rem;
          }

        }
         .topAgreement{
            font-weight:500;
            font-size: 0.2rem;
            color:rgba(170,170,170,1);
            margin-top: 0.1rem;
          }

         
        }



      }
    
     
   }
 
</style>

